// src/components/home/ProgramsSection.jsx
import {React, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

// Images
import cardBg1 from '../../assets/A-card-bg1.png';
import cardBg2 from '../../assets/A-card-bg2.png';
import doctor from '../../assets/doctors4.png';
import herbs from '../../assets/A-image12.png';
import doctorbg from '../../assets/program-bg.png';
import stemImage from '../../assets/stemImage4.png';

const ProgramsSection = () => {
  const navigate = useNavigate();
  // Add this inside ProgramsSection.jsx
useEffect(() => {
  const cards = document.querySelectorAll(".programs-parallax-card");

  const range = 40;
  const calcValue = (a, b) => (a / b * range - range / 2).toFixed(1);
  let timeout;

  const handleMouseMove = (e) => {
    if (timeout) window.cancelAnimationFrame(timeout);
    timeout = window.requestAnimationFrame(() => {
      const yValue = calcValue(e.clientY, window.innerHeight);
      const xValue = calcValue(e.clientX, window.innerWidth);

      cards.forEach(card => {
        card.style.transform = `rotateX(${yValue}deg) rotateY(${xValue}deg)`;

        const img = card.querySelector(".programs-parallax-card__img");
        const bg = card.querySelector(".programs-parallax-card__bg");

        if (img) {
          img.style.transform = `
            translateX(${-xValue * 1.5}px)
            translateY(${yValue * 1.5}px)
            translateZ(60px)
          `;
        }
        if (bg) {
          bg.style.backgroundPosition = `
            ${xValue * 0.3}px
            ${-yValue * 0.3}px
          `;
        }
      });
    });
  };

  document.addEventListener("mousemove", handleMouseMove);
  return () => document.removeEventListener("mousemove", handleMouseMove);
}, []);

  return (
    <section id="programs" className="bg-[#F1EAE1] py-[8rem] sm:py-20 md:py-24 px-4 sm:px-6 md:px-8 font-serif relative overflow-hidden">
      <img
  src={stemImage}
  alt="Decorative stem"
  className="absolute top-0 left-0 w-16 sm:w-20 md:w-72 animate-float"
/>
  {/* Top: Badge and Header */}
  <div className="programs-top text-center mb-8 sm:mb-12">
    <div className="programs-header inline-block text-center">
      <div className="treatments-badge inline-block border border-teal-900 text-teal-900 px-4 sm:px-6 py-2 rounded-full text-xl mb-4 sm:mb-6">
         Programs
      </div>
      <h2 className="text-3xl sm:text-4xl md:text-[2.5rem] font-bold text-black-900 mb-3 sm:mb-4 leading-tight">
        Upcoming Healing Programs
      </h2>
      <p className="text-base sm:text-lg text-black-700 leading-[1.5] font-light max-w-4/5 mx-auto px-2">
        Join our specialized Ayurveda workshops for holistic rejuvenation sessions guided by expert practitioners
      </p>
    </div>
  </div>

  <div className="programs-content flex flex-col lg:flex-row lg:justify-between lg:items-stretch max-w-6xl mx-auto mb-8 sm:mb-16 w-full gap-8 sm:gap-12 lg:gap-20 xl:gap-32 px-2">
    
    {/* Left: Cards - NO ANIMATION (original styling) */}
    <div
      className="programs-left-cards flex-1 h-auto lg:h-full flex flex-col bg-cover bg-center bg-no-repeat p-4 sm:p-6 md:p-8 rounded-2xl lg:rounded-l-3xl justify-center items-center relative border-r-0" style={{ backgroundImage: `url(${cardBg1})` }}
    >
      {/* Programs Cards */}
      <div className="programs-cards flex-1 flex flex-col gap-4 sm:gap-6 mb-6 sm:mb-8 w-full max-w-[300px] sm:max-w-[350px] self-center z-10">
        {/* Card 1 */}
        <div className="program-card bg-white p-4 sm:p-5 rounded-xl shadow-md relative transition-shadow duration-300 w-full max-w-[280px] sm:max-w-[300px] mx-auto hover:shadow-lg">
          <div className="card-date bg-green-50 text-teal-900 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium mb-2 inline-block">
            17 October
          </div>
          <h3 className="text-base sm:text-lg text-black-900 mb-1 font-bold leading-tight">
            Herbal Detox & Rejuvenation
          </h3>
          <p className="text-xs sm:text-sm text-[#0B2A2C] mb-0">
            With Dr. Meera Sharma
          </p>
          <span className="arrow absolute top-1/2 right-2 sm:right-3 -translate-y-1/2 text-teal-900 text-lg sm:text-xl font-bold">
            →
          </span>
        </div>
        {/* Card 2 */}
        <div className="program-card bg-white p-4 sm:p-5 rounded-xl shadow-md relative transition-shadow duration-300 w-full max-w-[280px] sm:max-w-[300px] mx-auto hover:shadow-lg">
          <div className="card-date bg-green-50 text-teal-900 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium mb-2 inline-block">
            23 October
          </div>
          <h3 className="text-base sm:text-lg text-black-900 mb-1 font-bold leading-tight">
            Stress Relief with Shirodhara
          </h3>
          <p className="text-xs sm:text-sm text-[#0B2A2C] mb-0">
            With Dr. Arjun Menon
          </p>
          <span className="arrow absolute top-1/2 right-2 sm:right-3 -translate-y-1/2 text-teal-900 text-lg sm:text-xl font-bold">
            →
          </span>
        </div>
        {/* Card 3 */}
        <div className="program-card bg-white p-4 sm:p-5 rounded-xl shadow-md relative transition-shadow duration-300 w-full max-w-[280px] sm:max-w-[300px] mx-auto hover:shadow-lg">
          <div className="card-date bg-green-50 text-teal-900 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium mb-2 inline-block">
            20 December
          </div>
          <h3 className="text-base sm:text-lg text-black-900 mb-1 font-bold leading-tight">
            Winter Immunity Boost Program
          </h3>
          <p className="text-xs sm:text-sm text-[#0B2A2C] mb-0">
            With Dr. Kavya Iyer
          </p>
          <span className="arrow absolute top-1/2 right-2 sm:right-3 -translate-y-1/2 text-teal-900 text-lg sm:text-xl font-bold">
            →
          </span>
        </div>
      </div>
      {/* View All Button */}
      <button className="solox-btn view-all-btn bg-[#0B2A2C] text-white hover:text-[#0B2A2C] border-2 border-[#0B2A2C] px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl cursor-pointer text-sm sm:text-base font-medium transition-colors duration-300 self-center hover:bg-teal-800 z-10 w-full sm:w-auto">
        <span>View All</span>
      </button>
    </div>

    {/* Right: Large Image with Pop-out Animation */}
    <div className="programs-right flex-1 h-auto lg:h-full relative overflow-hidden max-w-full lg:max-w-[500px] flex items-stretch order-first lg:order-last">
      <div className="relative group w-full h-full">
        {/* Background Container - Same size as image container */}
        {/* <div className="absolute w-full h-64 sm:h-80 lg:h-[180%] lg:mt-[] lg:mb-[40%] rounded-2xl lg:rounded-t-3xl lg:rounded-b-none bg-[#E8DFD1] transform translate-y-4 translate-x-4 group-hover:translate-y-6 group-hover:translate-x-6 transition-all duration-300 z-0"></div> */}
        
        {/* Main Image with Pop-out */}
        
        
        {/* <div className="programs-parallax-card programs-parallax-card-main w-full h-64 sm:h-80 lg:h-[180%] lg:mt-[40%] lg:mb-[40%] rounded-2xl lg:rounded-t-3xl lg:rounded-b-none relative transform transition-all duration-500 z-10"> */}
          <div className='programs-parallax-card'>
          <div 
            // className="programs-parallax-card__bg absolute inset-0 bg-cover bg-center"
            className='bg-cover bg-repeat bg-center programs-parallax-card__bg absolute inset-0 '
            style={{ 
              backgroundImage: `url(${doctorbg})`,
              // transform: 'translateZ(-60px) scale(1.5)',
              // filter: 'blur(1px) brightness(0.8)'
            }}
          ></div>
          
          <img
            src={doctor}
            alt="Two Ayurveda specialists with herbal bottles"
            className="programs-parallax-card__img absolute inset-0 w-full h-full object-cover "
            style={{ transform: 'translateZ(40px)' }}
          />
        </div>
      </div>
    </div>
  </div>

  {/* Bottom CTA Section - Small Image with Animation Only */}
 {/* Bottom CTA Section - Responsive flex with wrapping */}
          <div className="cta-section bg-[#0B2A2C] p-4 sm:p-6 md:p-8 rounded-xl max-w-6xl mx-auto">
  <div className="cta-content 
        grid grid-cols-1 lg:grid-cols-3 
        gap-6 sm:gap-8 text-[#F1EAE1]
        items-stretch">

    {/* LEFT CARD */}
    <div className="cta-left bg-transparent p-0 flex flex-col justify-between 
                    rounded-xl h-full">
      <div>
        <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 leading-tight">
          Consult with an Ayurvedic Specialist
        </h3>
        <p className="text-sm sm:text-base leading-[1.5] mb-4 sm:mb-6 opacity-95">
          Experience natural healing through personalized Ayurvedic consultations.
          Holistic treatments, herbal remedies, and lifestyle balance.
        </p>
      </div>

      <button 
      onClick={() => navigate("/BookNow")}
      className="solox-btn solox-btn--light text-white hover:text-[#0B2A2C] border-2 border-[#0B2A2C] px-4 sm:px-6 py-2.5 sm:py-3 
                         rounded-xl cursor-pointer text-sm sm:text-base font-medium 
                         hover:bg-gray-100 transition-colors duration-300 w-full"
                         style={{ '--solox-btn-bg': '#F1EAE1' }}>
        <span>Book Consultation</span>
        
      </button>
    </div>

    {/* MIDDLE CARD */}
    <div
      className="cta-middle bg-white/10 bg-cover p-4 sm:p-6 md:p-8 rounded-xl text-center 
                 text-teal-900/90 h-full flex flex-col justify-center"
      style={{ backgroundImage: `url(${cardBg2})` }}
    >
      <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">
        Visit or Contact Us
      </h4>

      <p className="text-xs sm:text-sm mb-1 opacity-90">
        Devi Oil Mill Building, 29-7-19/1,
        Vishnuvardhana Rao Street, Mil Road,
        Opp. Indla Rama Subba Reddy Hospital
      </p>

      <p className="text-xs sm:text-sm mb-1 opacity-90">
        Suryaraopeta, Vijayawada, Andhra Pradesh 520002
      </p>

      <p className="text-xs sm:text-sm mb-1 opacity-90">+91 92470 11552</p>
      <p className="text-xs sm:text-sm opacity-90">care@ayurwellness.in</p>
    </div>

    {/* RIGHT CARD */}
    <div className="cta-right rounded-xl overflow-hidden shadow-lg h-full">
      <img
        src={herbs}
        alt="Consultation with herbs"
        className="w-full h-full object-cover"
      />
    </div>

  </div>
</div>

</section>
  );
};

export default ProgramsSection;